import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const sliceName = "cardView";

const initialState = {
    isSideMenuOpen: false,
    isReverting: false,
}

const cardViewSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        openExtraActionsMenu(state) {
            state.isSideMenuOpen = true;
        },

        closeExtraActionsMenu(state) {
            state.isSideMenuOpen = false;
        },

        setReverting(state, action: PayloadAction<boolean>) {
            state.isReverting = action.payload;
        },
    }
});

export const cardViewReducer = cardViewSlice.reducer;

export const cardViewActions = cardViewSlice.actions;
